export function flattenMap (value, key, flatMap = {}) {
  if (typeof value === 'string') {
    flatMap[key] = value
  } else {
    Object.entries(value).forEach(([propKey, value]) =>
      flattenMap(value, key ? key + '.' + propKey : propKey, flatMap)
    )
  }

  return flatMap
}
